// Built-in React
import React from "react";

// Componenti Figli
import LocationItem from "./LocationItem";

// Librerie Esterne
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';

interface LocationSearchProps {
    seo: boolean;
}

const LocationSearch: React.FC<LocationSearchProps> = ({ seo }) => {
    const { t } = useTranslation();

    // Dati delle location
    const places = [
        {
            name: t('homePage.locationsSection.location1.name'),
            subTitle: t('homePage.locationsSection.location1.subTitle'),
            imageUrl: t('homePage.locationsSection.location1.imageUrl'),
            link: "/immobili/siena",
            description: t('homePage.locationsSection.location1.description')
        },
        {
            name: t('homePage.locationsSection.location2.name'),
            subTitle: t('homePage.locationsSection.location2.subTitle'),
            imageUrl: t('homePage.locationsSection.location2.imageUrl'),
            link: "/immobili/siena/murlo",
            description: t('homePage.locationsSection.location2.description')
        },
    ];

    return (
        <section id="search-for-location" className="space-ptb">
            {seo ? (
                <h2 className="mb-4 mb-5">{t('homePage.locationsSection.title1')}</h2>
            ) : (
                <h3 className="asH2SubTitle">{t('homePage.locationsSection.title2')}</h3>
            )}
            <div className="container-fluid">
                <Carousel controls={false} indicators={true} interval={5000} pause={'hover'} fade>
                    {places.map((place) => (
                        <Carousel.Item key={place.name}>
                            <LocationItem
                                name={place.name}
                                subTitle={place.subTitle}
                                imageUrl={place.imageUrl}
                                link={place.link}
                                description={place.description}
                            />
                        </Carousel.Item>
                    ))}
                </Carousel>
            </div>
        </section>
    );
};

export default LocationSearch;